module.exports = "<div class=\"ai-content\" id=\"cx-ai-box\" ng-click=\"vm.stopEventBubbling($event);\">\r\n  <div class=\"ai-content__details\">\r\n    <span class=\"icon--search-ai-suggestion\"></span>\r\n    <div class=\"ai-content__details-text\">\r\n      {{vm.staticSuggestionText}}&nbsp;<span class=\"ai-content--semibold\">{{vm.suggestionText}}</span>\r\n    </div>\r\n  </div>\r\n  <div class=\"ai-content__cancel\" ng-click=\"vm.closeAISuggestionBox($event)\">\r\n    <span class=\"icon--search-ai-cancel\"></span>\r\n  </div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/search/search-ai-content-template.html
 ** module id = 990
 ** module chunks = 1
 **/